import { NextSeo } from 'next-seo';
import Hero from '../components/landing/Hero';
import Welcome from '../components/landing/Welcome';
import Features from '../components/landing/Features';
import WebOns from '../components/landing/WebOns';
import Build from '../components/landing/Build';
import Community from '../components/landing/Community';
import FAQ from '../components/landing/FAQ';
import CTA from '../components/landing/CTA';
import Footer from '../components/landing/Footer';

export default function Home() {
  return (
    <>
      <NextSeo
        title="NOMO — The Premium Gateway to the Decentralized World"
        description="NOMO. Web3. Banking. Identity. Community. Unified."
      />
      <main>
        <Hero />
        <Welcome />
        <Features />
        <WebOns />
        <Build />
        <Community />
        <FAQ />
        <CTA />
      </main>
      <Footer />
    </>
  );
}
